import React from 'react';

const Logo = () => {
    return (
        <div className="logo">
            <b>A-LINE</b>
            <br/>
            <b>TATTOO</b>
        </div>
    );
};

export default Logo;